import { styled } from "@mui/material/styles";
import { Box, Typography, Alert, TableCell, TableRow } from "@mui/material";
import { colors } from "../../../theme/theme";
import { CustomBtn } from "../../../components/Common/CustomBtn";

export const PageWrapper = styled(Box)({
  minHeight: "100vh",
  paddingBottom: 32,
});

export const ContentBox = styled(Box)(({ theme }) => ({
  marginTop: 24,
  width: "100%",
  textAlign: "left",
  [theme.breakpoints.down("sm")]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const LoadingBox = styled(Box)({
  display: "flex",
  justifyContent: "center",
  paddingTop: 32,
  paddingBottom: 32,
});

export const ErrorAlert = styled(Alert)({
  marginTop: 16,
  marginLeft: 24,
  marginRight: 24,
  borderRadius: "14px",
  border: `1px dashed rgba(198, 40, 40, 0.5)`,
  backgroundColor: "rgba(198, 40, 40, 0.05)",
  fontFamily: "'Gotham', sans-serif",
});

export const InfoAlertTypography = styled(Typography)({
  fontFamily: "'Gotham', sans-serif",
  fontSize: 14,
});

export const InfoAlert = styled(Alert)(({ theme }) => ({
  marginTop: 16,
  marginLeft: 24,
  marginRight: 24,
  borderRadius: "14px",
  border: `1px dashed ${colors.primary}`,
  backgroundColor: `${colors.primary}10`,
  fontFamily: "'Gotham', sans-serif",
  [theme.breakpoints.down("sm")]: {
    margin: "16px 0 0",
  },
}));

export const StyledTableContainer = styled(Box)({
  borderRadius: "14px",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  border: `1px solid ${colors.primary}20`,
});

export const TableHeaderRow = styled(TableRow)({
  backgroundColor: colors.primary,
});

export const TableHeaderCell = styled(TableCell)({
  fontWeight: 700,
  fontSize: 14,
  color: "white",
  fontFamily: "'Gotham', sans-serif",
});

export const TableBodyRow = styled(TableRow)({
  backgroundColor: "#FAFAFA",
  "&:hover": {
    cursor: "pointer",
  },
});

export const TableBodyCell = styled(TableCell)({
  fontWeight: 500,
  color: colors.primary,
  fontFamily: "'Gotham', sans-serif",
});

export const EmptyStateBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant = "default" }) => ({
  marginTop: 32,
  padding: 48,
  textAlign: "center",
  borderRadius: "14px",
  ...(variant === "primary"
    ? {
        border: `1px dashed ${colors.primary}`,
        backgroundColor: `${colors.primary}05`,
      }
    : variant === "white"
    ? {
        border: "1px dashed #FFF",
        backgroundColor: `${colors.primary}05`,
      }
    : {
        border: `1px dashed #FFF`,
        backgroundColor: `${colors.primary}05`,
      }),
}));

export const EmptyStateTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant = "default", theme }) => ({
  fontSize: 18,
  marginBottom: 16,
  fontWeight: 600,
  fontFamily: "'Gotham', sans-serif",
  ...(variant === "primary" && { color: colors.primary }),
  ...(variant === "white" && { color: colors.textLight }),
  [theme.breakpoints.down("md")]: {
    fontSize: 16,
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: 14,
  },
}));

export const EmptyStateText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "variant",
})(({ variant = "default", theme }) => ({
  fontSize: 14,
  fontFamily: "'Gotham', sans-serif",
  ...(variant === "primary" && { color: colors.primary }),
  ...(variant === "white" && { color: colors.textLight }),
  ...(variant === "default" && { opacity: 0.8 }),
  [theme.breakpoints.down("md")]: {
    fontSize: 14,
  },
}));

export const ActionsBox = styled(Box)({
  display: "flex",
  gap: 8,
  flexWrap: "wrap",
});

export const StyledButton = styled(CustomBtn)({
  width: "auto",
});
